import React from 'react'
import { Alert, AlertIcon, IconButton, Spacer } from '@chakra-ui/react'
import { CloseIcon } from '@chakra-ui/icons'

const Message = ({ type, message, onClose = v => v }) => {
  return (
    <Alert
      status={type}
      mb="16px">
      <AlertIcon color="brand.red" />
      {message}
      <Spacer />
      <CloseButton onClick={onClose} />
    </Alert>
  )
}

const CloseButton = ({ onClick }) => (
  <IconButton
    aria-label="close-message"
    onClick={onClick}
    size="xs"
    variant="transparent"
    justifySelf="flex-end"
    icon={<CloseIcon color="brand.black" />}
  />
)
Message.propTypes = {}

export default Message
